import { apiDelete, apiGet, apiPost, apiPut, queryString, type ApiResult } from "./client";
import type { Course } from "./types";

export async function fetchCourses(includeArchived: boolean): Promise<ApiResult<Course[]>> {
  return apiGet<Course[]>("/courses" + queryString({ includeArchived }));
}

export async function createCourse(name: string, note: string): Promise<ApiResult<Course>> {
  return apiPost<Course>("/courses", { name, note });
}

export async function updateCourse(id: string, name: string, note: string,
  version: number): Promise<ApiResult<Course>> {
  return apiPut<Course>(`/courses/${id}`, { name, note, version });
}

export async function setCourseArchived(id: string, archived: boolean, version: number): Promise<ApiResult<Course>> {
  const action: string = archived ? "archive" : "unarchive";
  return apiPost<Course>(`/courses/${id}/${action}`, { version });
}

export async function deleteCourse(id: string): Promise<ApiResult<null>> {
  return apiDelete<null>(`/courses/${id}`);
}
